import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FlexContainer from '../../styled/FlexContainer'
import {
  CheckmarkSelect,
  MentorChecks,
  StudentChecks
} from './_Styled'
import { LexiconContext } from '../../../contexts/Lexicon'

export default class MentorStudentFilter extends Component {
  static contextType = LexiconContext

  render () {
    const { lexicon } = this.context

    return (
      <FlexContainer
        style={{
          margin: '20px auto 0',
          width: '480px',
          justifyContent: this.props.noStudentOption
            ? 'flex-end'
            : 'space-evenly'
        }}
      >
        {!this.props.noStudentOption && (
          <FlexContainer
            style={{ cursor: 'pointer' }}
            onClick={this.props.onStudentChecksClick}
          >
            <CheckmarkSelect
              color={'#90B1C3'}
              className={this.props.viewingStudentChecks ? 'selected' : ''}
            />
            <StudentChecks>
              {this.props.isMentor ? 'Student' : 'My'} Reflections
            </StudentChecks>
          </FlexContainer>
        )}
        <FlexContainer
          style={{ cursor: this.props.noStudentOption ? 'default' : 'pointer' }}
          onClick={this.props.onMentorChecksClick}
        >
          {!this.props.noStudentOption && (
            <CheckmarkSelect
              color={'#4E6C84'}
              className={this.props.viewingMentorChecks ? 'selected' : ''}
            />
          )}
          <MentorChecks>
            {lexicon.mentor} Feedback
          </MentorChecks>
        </FlexContainer>
      </FlexContainer>
    )
  }
}

MentorStudentFilter.propTypes = {
  isMentor: PropTypes.bool,
  viewingStudentChecks: PropTypes.bool,
  viewingMentorChecks: PropTypes.bool,
  onStudentChecksClick: PropTypes.func,
  onMentorChecksClick: PropTypes.func
}
